import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key';
import { ORGANIZATION_ROLES } from '@/enums/organization-roles.enum.ts';

const elevatedInviteRoleEnum = z.enum([
  ORGANIZATION_ROLES.OWNER,
  ORGANIZATION_ROLES.ADMIN,
  ORGANIZATION_ROLES.PROCUREMENT,
  ORGANIZATION_ROLES.CONTENT_MANAGER,
  ORGANIZATION_ROLES.EVENT_PLANNER,
  ORGANIZATION_ROLES.EVENT_ORGANIZER,
]);

export const inviteToOrganizationSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    name: z
      .string()
      .min(2, t('organization.invite.validation.nameMinLength'))
      .trim()
      .regex(/^[a-zA-Z0-9äöüÄÖÜß\s\-&'.]+$/, t('organization.validation.nameCharacters')),
    email: z
      .string()
      .email(t('organization.validation.emailInvalid'))
      .min(1, t('organization.validation.emailRequired')),
    message: z.string().trim(),
    elevatedRoles: z.array(elevatedInviteRoleEnum),
  });
};
